import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthURL } from "../../../routes/auth_routes/AuthURL";
import { PublicURL } from "../../../routes/public_routes/PublicURL";
// import BrandLogo from "../../../img/brand/logo.png";
import "../../../css/components/page_wrappers/common/Header.css";

const Header = () => {
	const brandName = process.env.REACT_APP_BRAND_NAME;
	const [scrolled, setScrolled] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);

	useEffect(() => {
		const handleScroll = () => { setScrolled(window.scrollY > 50); };
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<div className="guest-page-main-header">
			<header className={`guest-page-header ${scrolled ? "scrolled" : ""}`}>
				<div className="header-container">
					{/* Left */}
					<div className="guest-page-header-logo">
						{/* <img src={BrandLogo} alt="logo" /> */}
						<span>
							<Link to={PublicURL.HOME} style={{ textDecoration: "none"}}>
								{brandName}
							</Link>
						</span>
					</div>

					{/* Center */}
					{/* <div className={`guest-page-header-nav-links ${menuOpen ? "open" : ""}`}>
						<Link to={PublicURL.HOME}>Features</Link>
						<Link to={PublicURL.HOME}>How It Works</Link>
						<Link to={PublicURL.HOME}>GST Filing</Link>
						<Link to={PublicURL.HOME}>Pricing</Link>
						<Link to={PublicURL.HOME}>For CAs</Link>
					</div> */}

					{/* Right */}
					<div className="guest-page-auth-buttons">
						<Link className="login" to={AuthURL.LOGIN}>Login</Link>
						{/* <Link className="signup">Sign Up</Link> */}
					</div>

					{/* Mobile Toggle */}
					<div className="guest-page-menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
						☰
					</div>
				</div>
			</header>
		</div>
	);
};

export default Header;
